export default ['api', function (api) {
    return {
        validate: (basketCode, promoCode) => {
            return api.get(`api/${basketCode}/promocode/${promoCode}`).
                then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/promo.api.service.js